import axios from "axios";
import baseURL from "../config/api";

export const post_FamilyMember = (data: any, token: string) => {
    return axios({
        url: `${baseURL}FamilyMember`,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const put_FamilyMember = (data: any, token: string) => {
    return axios({
        url: `${baseURL}FamilyMember`,
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const delete_FamilyMember = (primaryKey: string, token: string) => {
    return axios({
        url: `${baseURL}FamilyMember`,
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: { id: primaryKey }
    }).then(response => response.data);
}

export const fetchAllFamilyMembersForExport = async (
    groupId: string,
    userId: number,
    exportedBy: string,
    token: string
) => {
    const response = await axios({
        url: `${baseURL}FamilyMember/GetFamilyMemberReportByGroupId/${groupId}`,
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params: {
            userId,
            exportedBy,
        },
        withCredentials: true,
    });

    return response.data;
};

export const getFamilyMembers = (token: string) => {
    return getFetch(`FamilyMember`, token)
}

export const getFamilyMember = (primaryKey: string, token: string) => {
    return getFetch(`FamilyMember/${primaryKey}`, token)
}

const getFetch = (url: string, token: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: params
    }).then(response => response.data);
}